import { render, staticRenderFns } from "./inner-setup.vue?vue&type=template&id=c84171c2&"
import script from "./inner-setup.vue?vue&type=script&setup=true&lang=js&"
export * from "./inner-setup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports